import DetailReceptionPeriodical from './DetailReceptionPeriodical.jsx';
export {
  DetailReceptionPeriodical
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/detail-reception-periodical/index.js